import { render } from "./Sala7Es.vue?vue&type=template&id=1ca4c832"
import script from "./Sala7Es.vue?vue&type=script&lang=js"
export * from "./Sala7Es.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marco\\Desktop\\archeo-guida-smart\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__